module.exports = __webpack_public_path__ + "fonts/overpass-regular.71096f93.otf";